// @flow
import api from 'tim-api';
import { termShowFinesTable } from 'endPoints';

export const state = {
  fineTableData: [],
};

export const getters = {
  fineTableDataGetter: (state: Object) => state.fineTableData,
};

export const mutations = {
  SET_FINE_TABLE_DATA(state: Object, fineTableData: Object) {
    state.fineTableData = fineTableData;
  },
};

export const actions = {
  fetchFineTableData({ commit }: Action, type: String = '') {
    commit('SET_FINE_TABLE_DATA', []);
    return api.get(`${termShowFinesTable}/${type}`).then(({ data }) => {
      commit('SET_FINE_TABLE_DATA', data);
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
